import React from "react";
import Button from '@material-ui/core/Button';

export default ({ label }) => (
    <Button type="submit"
            fullWidth
            color="primary"
            className="common-submit"
            size="large"
            variant="contained" >{label}</Button>
);



// WEBPACK FOOTER //
// ./src/components/SubmitButton.js